function handleHeaderOnScroll() {
  $(window).on('scroll', function() {
    if (
      $(window).width() > 768 &&
      window.location.href.indexOf('/products/') > -1
    ) {
      $('.product .header').removeAttr('sticky');
    }
  });
}

// Run when DOM is ready
$(document).ready(function() {
  handleHeaderOnScroll();
});

// Also run when Shopify sections are reloaded (important for product pages)
document.addEventListener('shopify:section:load', handleHeaderOnScroll);
document.addEventListener('shopify:section:reorder', handleHeaderOnScroll);
